import { CreateUserAdminPayload, GetUsersAdminParams, UserDetail } from '../../dto/User';
import { baseApiWithCompanyId } from 'src/redux/services/baseApi';

export interface GetUsersAdminResponse {
  items: UserDetail[];
  total: number;
  filters: GetUsersAdminParams;
}
export const usersAdminApi = baseApiWithCompanyId.injectEndpoints({
  endpoints: (builder) => ({
    getUsersAdmin: builder.query<GetUsersAdminResponse, GetUsersAdminParams>({
      query: (params) => ({
        url: '/v2/users',
        params: {
          ...params,
          search: params.search || undefined,
        },
      }),
      providesTags: ['UsersAdmin'],
    }),
    getUserAdmin: builder.query<UserDetail, string>({
      query: (id) => `v2/users/${id}`,
      providesTags: ['UserAdminDetail'],
    }),
    createUserAdmin: builder.mutation<UserDetail, CreateUserAdminPayload>({
      query(data) {
        return {
          url: '/v2/users',
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['UsersAdmin', 'UserAdminDetail'],
    }),
    updateUserAdmin: builder.mutation<UserDetail, UserDetail>({
      query(data) {
        return {
          url: '/v2/users',
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: ['UsersAdmin', 'UserAdminDetail'],
    }),
  }),
});

export const { useGetUserAdminQuery, useGetUsersAdminQuery, useCreateUserAdminMutation, useUpdateUserAdminMutation } = usersAdminApi;
